import React, { useCallback, useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import useFetch from '../../../hooks/useFetch';
import MainLayout from '../../../layouts/MainLayout';
import '../styles/MCQPractice.css';
import { useSelector } from 'react-redux';
import Loader from '../../../components/utils/Loader';
import Tooltip from '../../../components/utils/Tooltip';

const KidleticsDashboard = () => {
    const authState = useSelector(state => state.authReducer);
    const [fetchData, { loading }] = useFetch();
    const navigate = useNavigate();
    const [userId, setUserId] = useState(authState.user._id);
    const [userData, setUserData] = useState(null);
    const [hasGetUserDataClicked, setHasGetUserDataClicked] = useState(false);
    const [hasEnrolledClicked, setHasEnrolledClicked] = useState(false);
    const [hasEnrollSubmitClicked, setHasEnrollSubmitClicked] = useState(false);


    const [error, setError] = useState(null);

    const handleAboutKidleticsClick = () => {
        navigate('/aboutkidletics');
    };

    const handleGetUserDataClick = () => {
        if (!authState.isLoggedIn) return;
        setHasGetUserDataClicked(true);
        // fetchUserData();
    };

    const fetchUserData = useCallback(() => {
        const config = {
            url: "/kidleticsusers/userdata",
            method: "post",
            headers: { Authorization: authState.token },
            data: { userId: userId }
        };

        fetchData(config, { showSuccessToast: false })
            .then(response => {
                // console.log("Response:", response);
                if (response && response.userdata) {
                    setUserData(response.userdata);
                } else {
                    console.error("Invalid response format: Kidzletics User Data not found in response");
                }
            })
            .catch(error => {
                console.error("Error fetching Kidzletics User Data:", error);
            });
    }, [authState.token, fetchData]);

    // useEffect(() => {
    //     if (!authState.isLoggedIn) return;
    //     fetchUserData();
    // }, [authState.isLoggedIn, fetchUserData]);

    const handleEnrollClick = () => {
        setHasEnrolledClicked(true);
    };

    const handleSubmitClick = () => {
        setHasEnrollSubmitClicked(true);
    };

    const formatDateTime = (date) => {
        const options = {
            year: 'numeric', month: '2-digit', day: '2-digit',
            hour: '2-digit', minute: '2-digit', second: '2-digit',
            hour12: false
        };
        const jsDate = new Date(date);
        const day = jsDate.getDate().toString().padStart(2, '0');
        const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
        const year = jsDate.getFullYear();
        const hours = jsDate.getHours().toString().padStart(2, '0');
        const minutes = jsDate.getMinutes().toString().padStart(2, '0');
        const seconds = jsDate.getSeconds().toString().padStart(2, '0');
        return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
    };


    return (
        <MainLayout>
            <div className='mb-4'>
                <h3 className='text-lg mt-1 mx-2 border-b border-b-gray-300 text-white'>Kidzletics</h3>
            </div>
            <div className="main-content text-white mt-4 mb-4 mr-4 ml-4 border border-gray-300">
                <div className='text-white mt-4'>
                    <button
                        type="button"
                        className="bg-green-600 text-white py-2 px-4 rounded-md font-medium hover:bg-primary-dark"
                        onClick={handleAboutKidleticsClick}
                    >
                        About Kidzletics
                    </button>
                </div>
                <div className='text-white mt-2 mb-4'>
                    <button
                        type="button"
                        className="bg-yellow-500 text-white py-2 px-4 rounded-md font-medium hover:bg-primary-dark"
                        onClick={handleGetUserDataClick}
                        disabled={hasGetUserDataClicked}
                    >
                        Get My Kidzletics Data
                    </button>
                    {hasGetUserDataClicked && (
                        <>
                            {userData && userData.length > 0 ? (
                                <div className='text-white'>
                                    <p><strong>User Code:</strong> {userData.userCode}</p>
                                    <p><strong>Total Points:</strong> {userData.totalPoints}</p>
                                    <p><strong>Enrollment Number:</strong> {userData.enrollmentNumber}</p>
                                    <p><strong>Enrollment Date:</strong> {new Date(userData.enrollmentDate).toLocaleDateString()}</p>
                                    {/* Add more fields as needed */}
                                </div>
                            ) : (
                                <>
                                    <div className='text-xl text-yellow-300 text-center'>
                                        <p><strong>Kidzletics User Data Not Found!!</strong></p>
                                    </div>
                                    <div className='text-xl text-yellow-300 text-center'>
                                        <button
                                            type="button"
                                            className="bg-yellow-500 text-white py-2 px-4 rounded-md font-medium hover:bg-primary-dark"
                                            onClick={handleEnrollClick}
                                        >
                                            Enroll Now
                                        </button>
                                    </div>
                                    {hasEnrolledClicked && (
                                        <>
                                        <div className='text-xl text-yellow-300 text-center'>
                                            <p><strong>Enrolled Clicked!</strong></p>
                                        </div>
                                        <button
                                            type="button"
                                            className="bg-yellow-500 text-white py-2 px-4 rounded-md font-medium hover:bg-primary-dark"
                                            onClick={handleSubmitClick}
                                        >
                                            Submit
                                        </button>
                                        </>
                                    )}
                                </>
                            )}
                        </>
                    )}
                </div>
            </div>
        </MainLayout>
    );
};

export default KidleticsDashboard;
